import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { Card } from '@indicia/component-library';
import useBem from '@indicia/use-bem';

import useSurveyContext from '../../../survey/store/UseSurveyContext';
import CategoryEnum from '../category/enums/CatergoryEnum';

import './Improvements.scss';

type PropType = {
  improvements: string[];
};

const Improvements = ({ improvements }: PropType) => {
  const { t } = useTranslation();
  const { bemClassName } = useBem('dashboard-improvements');
  const { getLink } = useSurveyContext();
  const location = useLocation();

  const improvementImages: Record<CategoryEnum, string> = {
    [CategoryEnum.Nutrition]: '/images/voeding_bron.jpg',
    [CategoryEnum.Weight]: '/images/gewicht_bron.jpg',
    [CategoryEnum.Coffee]: '/images/koffie_bron.jpg',
    [CategoryEnum.Sleep]: '/images/slapen_bron.jpg',
    [CategoryEnum.Smoking]: '/images/roken_bron.jpg',
    [CategoryEnum.Exercise]: '/images/bewegen_bron.jpg',
    [CategoryEnum.Cholesterol]: '/images/cholesterol_bron.jpg',
    [CategoryEnum.Alcohol]: '/images/alcohol_bron.jpg',
    [CategoryEnum.Stress]: '/images/stress_bron.jpg',
    [CategoryEnum.Vitals]: '/images/bloeddruk_bron.jpg',
  };

  const getImprovementImage = (improvement: string): string => improvementImages[improvement as CategoryEnum];

  return (
    <div className={bemClassName()}>
      <div className={bemClassName('list')}>
        {improvements.map((improvement) => (
          <div
            key={improvement}
            className={bemClassName('item')}
          >
            <Link
              className="link"
              to={getLink(improvement)}
              state={{ from: location.pathname }}
            >
              <Card image={getImprovementImage(improvement)}>
                <div className={bemClassName('card-inner')}>
                  <div className={bemClassName('card-summary')}>
                    <h3>{t(`dashboard.categories.${improvement}`)}</h3>
                  </div>
                  <p className={bemClassName('card-details')}>{t('dashboard.improvements.improve-description')}</p>
                </div>
              </Card>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Improvements;
